import { render } from "./SettingsPanel.vue?vue&type=template&id=a4ec0fe8&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"

import "./SettingsPanel.vue?vue&type=style&index=0&id=a4ec0fe8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ec0fe8"]])

export default __exports__